import toast from "react-hot-toast";

export default (error: any) => {
  handleOpenConfirmLogoutBox();
  toast.error('authentication failed', {
    position: 'top-left',
    duration: 5000,
  });
}

const handleOpenConfirmLogoutBox = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('role');
  localStorage.removeItem('userId');
  window.location.href = '/login';
};